import { schema } from 'normalizr';

export const settlementAccount = new schema.Entity('settlementAccounts');
export const settlementAccounts = [settlementAccount];

settlementAccount.define({
  portfolio: require('shared/store/modules/portfolios/schemas').portfolio
});
